import { useAuth } from "@/hooks/useAuth";
import HomeHero from "@/components/home/HomeHero";
import HomeStatStrip from "@/components/home/HomeStatStrip";
import HomeTimingBoard from "@/components/home/HomeTimingBoard";
import HomeFeatureRows from "@/components/home/HomeFeatureRows";
import HomeEventsSection from "@/components/home/HomeEventsSection";
import HomeClosingCta from "@/components/home/HomeClosingCta";
import HomeFooter from "@/components/home/HomeFooter";

/**
 * Marketing landing for `/`. Leads with Trackcast (in-car live-casting) and
 * then the platform around it: team & fleet, analysis, bring-your-own gear.
 * Mock visuals live under components/home/mocks and are illustrative only.
 */
export default function HomePage() {
  const { user } = useAuth();
  const signedIn = Boolean(user);

  return (
    <div className="min-h-screen bg-gray-950">
      <HomeHero signedIn={signedIn} />
      <HomeStatStrip />
      <HomeTimingBoard />
      <HomeFeatureRows />
      <HomeEventsSection />
      <HomeClosingCta signedIn={signedIn} />
      <HomeFooter />
    </div>
  );
}
